export default __webpack_public_path__ + "static/media/jay_maharaj.f8ede424.jpeg";